export interface ConfigState {
  width: number;
  height: number;
  baseSpanInDegree: number;
  strokeWidth: number;
}

export const KINDS: Record<string, string> = {
  warning: 'warning',
  success: 'success',
  critical: 'critical',
  info: 'info',
} as const;

export const CHIPS: Record<string, string> = {
  outlined: 'outlined',
  plain: 'plain',
} as const;

export const SIZES: Record<string, string> = {
  small: 'small',
  regular: 'regular',
} as const;

export const REGULAR_CONFIG: ConfigState = {
  width: 75,
  height: 75,
  baseSpanInDegree: 250,
  strokeWidth: 7,
} as const;

export const SMALL_CONFIG: ConfigState = {
  width: 50,
  height: 50,
  baseSpanInDegree: 200,
  strokeWidth: 5,
} as const;

export const CONFIG: Record<string, ConfigState> = {
  [SIZES.small]: SMALL_CONFIG,
  [SIZES.regular]: REGULAR_CONFIG,
} as const;
